import './index.scss';
import React, { useState, useEffect, useRef } from 'react';
import { Toast } from 'antd-mobile';

import { dropdown, info } from '@/services/saas/tenant';
import { accountLogin } from '@/services/saas/user';
import ico_account from '@/images/ico_login_account.png';
import ico_password from '@/images/ico_login_password.png';
import ico_tenant from '@/images/ico_login_tenant.png';
import { setTenantInfo } from '../../utils';

const Login = () => {
  const [showPass, setShowPass] = useState(false);
  const [tenant, setTenant] = useState({ list: [], bindDomain: false, initTenantId: '000000' });
  const { list, bindDomain, initTenantId } = tenant;
  const tenantRef = useRef();
  const accountRef = useRef();
  const passwordRef = useRef();
  const showTenant = !(list.length === 1 || bindDomain);

  const init = async () => {
    const responsive = await dropdown();
    const responsiveInfo = await info({ domain: window.location.hostname });
    if (responsive.success && responsiveInfo.success) {
      setTenantInfo(responsiveInfo.data);
      const state = { list: responsive.data, bindDomain: !!responsiveInfo.data.domain };
      if (!!responsiveInfo.data.domain) {
        state.initTenantId = responsiveInfo.data.tenantId;
      }
      setTenant((tenant) => ({
        ...tenant,
        ...state,
      }));
    }
  };

  const getParam = () => {
    const paylod = { username: accountRef.current.value, password: passwordRef.current.value };
    if (showTenant) {
      paylod.tenantId = tenantRef.current.value;
      if (!paylod.tenantId) {
        return Toast.info('请输入租户ID');
      }
    }
    if (!paylod.username) {
      return Toast.info('请输入账户');
    }
    if (!paylod.password) {
      return Toast.info('请输入密码');
    }
    return { tenantId: initTenantId, ...paylod };
  };

  const submit = async () => {
    const payload = getParam();
    if (!payload) {
      return;
    }
    const response = await accountLogin(payload);
    if (response.error_description) {
      Toast.fail(response.error_description);
    } else if (Object.keys(response).length > 0) {
      const { token_type, access_token } = response;
      const token = `${token_type} ${access_token}`;
      window.location = `/apps/home?platformType=saas&token=${token}`;
    }
  };

  useEffect(() => {
    init();
  }, []);

  return (
    <div className="login">
      <div className="login-card">
        {/* <h3 className="title">欢迎来到小步云</h3> */}
        <div className="login-form">
          {showTenant ? (
            <div className="login-form-item">
              <div className="prev-icon">
                <img src={ico_tenant} alt="ico_account" />
              </div>
              <div className="wrapper">
                <input type="text" placeholder="请输入租户" ref={tenantRef} />
              </div>
            </div>
          ) : null}
          <div className="login-form-item">
            <div className="prev-icon">
              <img src={ico_account} alt="ico_account" />
            </div>
            <div className="wrapper">
              <input type="text" placeholder="请输入账号" ref={accountRef} />
            </div>
          </div>
          <div className="login-form-item">
            <div className="prev-icon">
              <img src={ico_password} alt="ico_password" />
            </div>
            <div className="wrapper wrapper-extra">
              <input
                type={showPass ? 'text' : 'password'}
                placeholder="请输入密码"
                ref={passwordRef}
              />
              <div className="extra">
                <em
                  className={`show-password-text ${showPass ? 'show' : 'not-show'}`}
                  onClick={() => {
                    setShowPass(!showPass);
                  }}
                />
              </div>
            </div>
          </div>
          <button
            className="login-button"
            onClick={() => {
              submit();
            }}
          >
            登录
          </button>
        </div>
      </div>
      <div className="login-bottom-bg"></div>
    </div>
  );
};

export default Login;
